import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function usePaintSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const material = useStore((state) => state.quote.material);

  const paintAndPrime = useStore((state) => state.quote.paintAndPrime);
  const primeChoice = useStore((state) => state.quote.prime);
  const customPaintOrStain = useStore(
    (state) => state.quote.customPaintOrStain,
  );
  const customPaintColor = useStore((state) => state.quote.customPaintColor);

  const btnChoice = paintAndPrime || primeChoice || customPaintOrStain || "";

  const paintColor = useStore((state) => state.quote.paintColor);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string, type: string) => {
    const checked = label === btnChoice;

    if (checked) {
      addToQuote({ [type]: "" }, type);
    } else {
      let updateObj = { [type]: label };
      let ignoreResetKey = "";

      switch (type) {
        case "paintAndPrime":
          updateObj["prime"] = "";
          updateObj["customPaintOrStain"] = "";

          if (primeChoice) {
            ignoreResetKey = "prime";
          } else if (customPaintOrStain) {
            ignoreResetKey = "customPaintOrStain";
          }
          break;
        case "prime":
          updateObj["paintAndPrime"] = "";
          updateObj["customPaintOrStain"] = "";

          if (paintAndPrime) {
            ignoreResetKey = "paintAndPrime";
          } else if (customPaintOrStain) {
            ignoreResetKey = "customPaintOrStain";
          }
          break;
        case "customPaintOrStain":
          updateObj["prime"] = "";
          updateObj["paintAndPrime"] = "";

          if (paintAndPrime) {
            ignoreResetKey = "paintAndPrime";
          } else if (primeChoice) {
            ignoreResetKey = "prime";
          }
          break;
        default:
          return;
      }

      addToQuote(updateObj, ignoreResetKey);
    }
  };

  const handleClickColor = (label: string) => {
    const checked = label === paintColor;

    addToQuote({
      paintColor: !checked ? label : "",
    });

    if (!checked && findRequired("Paint Color")) {
      removeRequired("Paint Color");
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (value.length <= 15) {
      addToQuote({ customPaintColor: value });

      if (findRequired("Custom Paint Color"))
        removeRequired("Custom Paint Color");
    }
  };

  return {
    handleChange,
    handleClickColor,
    handleClick,
    customPaintColor,
    material,
    customPaintOrStain,
    paintAndPrime,
    paintColor,
    btnChoice,
  };
}

export default usePaintSelector;
